import CutwiseAPIClient, { METHOD_GET, METHOD_PATCH } from '@/common/network/CutwiseAPIClient';
import QueryResult from '@/common/network/QueryResult';

import { UserModel } from '../entity/User';

export const PATH_PROFILE = 'api/v2/user/info';
export const PATH_USER_SETTINGS = 'api/v2/user/settings';
export const PATH_USER_SEARCH = 'api/v2/user/search';
export const PATH_COMPANY_USERS = 'api/v2/user/listMy';

export default class UserAPI {
  fetchItem(): Promise<QueryResult<UserModel>> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_GET).path(PATH_PROFILE);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  fetchCompanyUsers(): Promise<QueryResult<Partial<UserModel>[]>> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_GET).path(PATH_COMPANY_USERS);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  fetchSettingsByKey(key: string): Promise<QueryResult> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_GET)
      .path(PATH_USER_SETTINGS)
      .addQueryStringParam('key', key);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  patchSettings(data: Record<string, Any>): Promise<QueryResult> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_PATCH).path(PATH_USER_SETTINGS).body(data);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  fetchUserByEmail(email: string): Promise<QueryResult<Partial<UserModel>[]>> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_GET)
      .path(PATH_USER_SEARCH)
      .addQueryStringParam('q', email);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }
}
